var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.loading)?_c('v-row',[_c('v-col',[_c('EditUserAuth',{attrs:{"userId":_vm.$route.params.userId}})],1),_c('v-col',[_c('EditUserProfile',{attrs:{"userId":_vm.$route.params.userId}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }